import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { normalizeComplianceResultDetail } from "./parseComplianceResult";
import type { ComplianceResultDetail } from "./types";

export const COMPLIANCE_RESULT_QUERY_KEY = [
  "regulator-portal",
  "compliance-result",
] as const;

export const complianceResultQueryKey = (resultId: string) =>
  [...COMPLIANCE_RESULT_QUERY_KEY, resultId] as const;

export const buildComplianceResultPath = (resultId: string): string =>
  API_ROUTES.REGULATOR_COMPLIANCE_RESULT_BY_ID.replace(
    "{result_id}",
    encodeURIComponent(resultId),
  );

export const fetchComplianceResult = async (
  resultId: string,
): Promise<ComplianceResultDetail | null> => {
  const response = await createRegulatorPortalInstance().get(
    buildComplianceResultPath(resultId),
  );
  return normalizeComplianceResultDetail(response.data);
};

export const useComplianceResult = (
  resultId?: string,
): UseQueryResult<ComplianceResultDetail | null, Error> =>
  useQuery<ComplianceResultDetail | null, Error>({
    queryKey: complianceResultQueryKey(resultId ?? ""),
    queryFn: () => fetchComplianceResult(resultId ?? ""),
    enabled: Boolean(resultId),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
